/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefOrganizationData } from '../../models/api-def-organization-data';

export interface OrganizationsGetById$Params {

/**
 * The ID of the organization to retrieve
 */
  organizationId: string;
}

export function organizationsGetById(http: HttpClient, rootUrl: string, params: OrganizationsGetById$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefOrganizationData>> {
  const rb = new RequestBuilder(rootUrl, organizationsGetById.PATH, 'get');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiDefOrganizationData>;
    })
  );
}

organizationsGetById.PATH = '/organizations/{organizationId}';
